import {Component, Input} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {UnternehmenAngaben} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
  selector: 'common-ui-taetigkeit-angaben',
  templateUrl: './taetigkeit-angaben.component.html',
  styleUrls: ['./taetigkeit-angaben.component.scss']
})
export class TaetigkeitAngabenComponent extends FormBaseComponent<UnternehmenAngaben> {

  @Input()
  public useBezeichnung = true;
  @Input()
  public useBeginnTaetigkeit = true;
  @Input()
  public beginnDerTaetigkeitStammdaten: string;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      artTaetigkeit: [this.data.artTaetigkeit, [
        this.validatorService.required(),
        this.validatorService.minLength(1),
        this.validatorService.maxLength(200)
      ]],
      bezeichnung: [this.data.bezeichnung,
        [
          this.validatorService.minLength(1),
          this.validatorService.maxLength(120)
        ]],
      beginnTaetigkeit: [this.data.beginnTaetigkeit,
        [
          this.validatorService.date()
        ]]
    });
  }
}
